const TiendasList = [
  "Alimentos y Gourmet",
  "Belleza y Cuidado Personal",
  "Bicicletas",
  "Camping y Outdoor",
  "Celulares y Tablets",
  "Computación",
  "Deportes",
  "Electrodomésticos",
  "Ferretería y automotriz",
  "GPS y Telefonía",
  "Infantil",
  "Joyería",
  "Juguetería",
  "Juguetería Exterior",
  "Lentes",
  "Libros y música",
  "Maletas y Mochilas",
  "Maquinarias y Complementos",
  "Mascotas",
  "Moda Hombre",
  "Moda Mujer",
  "Mundo Autos y Motos",
  "Mundo Hogar",
  "Relojes",
  "Ropa Deportiva",
  "Salud y Bienestar",
  "TV, Audio y Fotografía",
  "Videojuegos",
  "Vinos, Cervezas y Licores",
  "Otras",
]

const RestaurantesList = [
  "Árabe",
  "Cafe",
  "Chilena",
  "Comida Casera",
  "Empanadas",
  "Internacional",
  "Italiana",
  "Panadería/Bollería",
  "Peruana",
  "Pescados y Mariscos",
  "Pizza",
  "Postres",
  "Saludable",
  "Sushi",
  "Venezolana",
  "Otras",
]

const ServiciosList = [["Servicio"]]

module.exports = {
  TiendasList,
  RestaurantesList,
  ServiciosList,
}
